<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="title">新型农村集体经济组织订单</div>
    <div class="closeBtn" @click="visible = false"></div>
    <div class="content">
      <a-table
        bordered
        :columns="columns"
        :data-source="orderList"
        :pagination="pagination"
        :scroll="{ y: 1050 }"
        @change="onOrderChange"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import { areaCompanyOrder } from '@/api/dashboard'
import to from 'await-to'
export default {
  name: 'Product',
  data() {
    return {
      visible: false,
      productList: [],
      current: 1,
      size: 27,
      total: 0,
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNumber',
          key: 'orderNumber',
          align: 'center',
          width: 110,
        },
        {
          title: '新型农村集体经济组织名称',
          dataIndex: 'companyName',
          key: 'companyName',
          align: 'center',
          width: 150,
        },
        {
          title: '企业客户',
          dataIndex: 'customerName',
          key: 'customerName',
          align: 'center',
          width: 80,
        },
        {
          title: '订单详情',
          dataIndex: 'materialInfo',
          key: 'materialInfo',
          align: 'center',
          width: 300,
        },
        {
          title: '订单金额（元）',
          dataIndex: 'orderAmount',
          key: 'orderAmount',
          align: 'center',
          width: 80,
        },
        {
          title: '支付方式',
          dataIndex: 'paymentMethod',
          key: 'paymentMethod',
          align: 'center',
          width: 70,
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          key: 'orderType',
          align: 'center',
          width: 70,
        },
        {
          title: '创建时间',
          dataIndex: 'transactionTime',
          key: 'transactionTime',
          align: 'center',
          width: 100,
        },
      ],
      orderList: [],
      pagination: {
        current: 1,
        pageSize: 11,
        total: 0,
      },
      company: {},
    }
  },
  methods: {
    show() {
      this.visible = true
      this.getOrder()
    },
    close() {
      this.visible = false
    },
    onOrderChange({ current }) {
      console.log(`output->current`, current)
      this.pagination.current = current
      this.getOrder()
    },
    async getOrder() {
      const [res, err] = await to(
        areaCompanyOrder({
          current: this.pagination.current,
          size: this.pagination.pageSize,
        }),
      )
      if (err) return
      this.orderList = res.data.list
      this.pagination.total = res.data.total
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3212px !important;
  height: 1564px !important;
  background: url('~@/img/datav/dialog_bg.png');
  background-size: 100% 100%;
  position: absolute;
  left: 329px;
  top: 423px;
  display: none;

  .title {
    font-size: 57px;
    text-align: center;
    line-height: 107px;
    margin-bottom: 87px;
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/datav/dialog_close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 0 62px;

    ::v-deep .ant-table {
      p {
        margin-bottom: 10px;
      }

      table {
        border-left: 1px solid #f5f5f5;
        border-top: 1px solid #f5f5f5;
      }

      .ant-table-thead {
        box-sizing: border-box;
        border: 0;
        border-color: #f5f5f5;
        font-size: 36px;
        line-height: 36px;
        background: #fff linear-gradient(180deg, #145fa3, #174da8);

        > tr > th {
          background: transparent;
          color: #fff;
          border-color: #f5f5f5;
          padding-top: 42px;
          padding-bottom: 42px;
        }
      }

      .ant-table-header {
        background: transparent;
      }

      .ant-table-body {
        background: transparent;

        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          border-radius: 15px;
          width: 17px;
          background-color: transparent;
        }

        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          border-radius: 15px;
          background-color: transparent;
        }

        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 15px;
          background: #46629a;
        }
      }

      .ant-table-tbody {
        font-size: 30px;
        line-height: 30px;
        color: #fff;

        > tr > td {
          border-color: #f5f5f5;
          padding-top: 29px;
          padding-bottom: 29px;
        }

        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: transparent;
        }
      }

      .ant-table-placeholder {
        background: transparent;
      }
    }

    ::v-deep .ant-pagination {
      width: 100%;
      text-align: center;

      > li {
        width: 58px;
        height: 58px;
        box-sizing: border-box;
        border: 2px solid #46639a;
        font-weight: normal;
        font-size: 24px;
        line-height: 54px;
        text-align: center;
        background-color: transparent;
        margin: 0 10px;

        .ant-pagination-item-link {
          background-color: transparent;
          border: 0;
        }

        a {
          color: #46629a;
        }

        &.ant-pagination-item-active {
          background-color: #46629a;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
}
</style>
